var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("AutomaticRelease.common.combinationTitle"),
                  name: "rulesCombination"
                }
              },
              [
                _c("Single-Rule", {
                  attrs: { "tab-index": "0", "config-module": "2022072501" }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("AutomaticRelease.common.ruleTitle"),
                  name: "SingleRule"
                }
              },
              [
                _c("Single-Rule", {
                  attrs: { "tab-index": "1", "config-module": "2022072502" }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t(
                    "AutomaticRelease.common.AutomaticOrderReleaseTriggerSettings"
                  ),
                  name: "TriggerTheSettings"
                }
              },
              [_c("TriggerTheSettings")],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t(
                    "AutomaticRelease.common.ReleaseGuaranteeSetting"
                  ),
                  name: "releaseGuaranteeSetting"
                }
              },
              [_c("ReleaseGuaranteeSetting")],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }